export enum ErrorPage {
  NOT_FOUND = '/404',
  NETWORK = '/errors/network',
  SERVICE_MAINTENANCE = '/errors/service-maintenance',
  UNAUTHORIZED = '/errors/unauthorized',
  SERVICE_FAILURE = '/errors/service-failure',
}
